module.exports = __webpack_public_path__ + "img/amex.e764765.svg";